import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalBonusComponent } from './modal-bonus.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BtnCloseModule} from '../../btn-close/btn-close.module';
import {FormGroupContextModule} from '../../../modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../../modules/form-group-context/form-group-simple/form-group-simple.module';
import {FormGroupSelectModule} from '../../../modules/form-group-context/form-group-select/form-group-select.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormGroupDateModule} from '../../../modules/form-group-context/form-group-date/form-group-date.module';
import {CheckInputModule} from "../../check-input/check-input.module";



@NgModule({
  declarations: [
    ModalBonusComponent
  ],
  exports: [
    ModalBonusComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    BtnCloseModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    FormGroupSelectModule,
    FormGroupDateModule,
    CheckInputModule
  ],
})
export class ModalBonusModule { }
